export enum PageType {
  Internal = 'internal',
  External = 'external',
}
